import { Inject, Injectable, Optional } from '@angular/core';

import {
  CONTEXT_EDITOR_ENABLED,
  ENABLE_TRANSLATION_UI_KEY,
  I18nConfig,
  I18N_CONFIG_TOKEN,
} from '../i18n.tokens';

@Injectable()
export class PhraseAppEditorService {
  public get installed(): boolean {
    return this.editorInstalled;
  }

  private editorInstalled: boolean = false;

  constructor(
    @Inject(I18N_CONFIG_TOKEN) private config: I18nConfig,
    @Optional()
    @Inject(CONTEXT_EDITOR_ENABLED)
    private editorEnabled: boolean,
  ) {
    if (this.editorEnabled && !this.editorInstalled) {
      this.installEditor(this.config.phraseAppProjectId);
      this.editorInstalled = true;
    }

    // @ts-ignore
    window['enable_translation_editor'] = () => this.setEnable(true);
    // @ts-ignore
    window['disable_translation_editor'] = () => this.setEnable(false);
  }

  private setEnable(enable: boolean): void {
    if ('localStorage' in window) {
      localStorage.setItem(ENABLE_TRANSLATION_UI_KEY, enable ? 'true' : 'false');
      window.location.reload();
    }
  }

  private installEditor(projectId: string): void {
    // @ts-ignore
    window['PHRASEAPP_CONFIG'] = {
      projectId,
      fullReparse: true,
    };

    const phraseapp = document.createElement('script');
    phraseapp.type = 'text/javascript';
    phraseapp.async = true;
    phraseapp.src = [
      'https://',
      'phraseapp.com/assets/in-context-editor/2.0/app.js?',
      new Date().getTime(),
    ].join('');
    const s = document.getElementsByTagName('script')[0];
    s!.parentNode!.insertBefore(phraseapp, s);
  }
}
